import styled from 'styled-components';

export const PhotoWrap = styled.picture`
    padding: 0;
    margin: 0;
    position: relative;
    background-color: #ECEFF1;
    min-height: 120px;
    max-height: 130px;
    overflow: hidden;

    img {
        width: 100%;
        border-radius: 4px;
    }
`;

export const PhotoButtons = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    display: grid;
    gap: 8px;
    align-content: center;
    justify-content: center;
`;